import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserInformationSetDialogComponent } from 'projects/shared/lib/components/shared/user/information-set-dialog/user-information-set-dialog.component';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { BasicError } from 'projects/shared/lib/error/basic-error';
import { CountryDto, UserInformationSetCommand } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { firstValueFrom } from 'rxjs';
import { CountryComboBoxComponent } from 'shared/components/shared/country-combo-box/country-combo-box.component';
import { CheckNewsletterComponent } from 'projects/shared/lib/components/shared/check/newsletter/check-newsletter.component';
import { ESalutationToOptionStringPipe } from 'projects/shared/lib/pipes/salutation/string/option/esalutation-to-option-string.pipe';

@Component({
  selector: 'app-user-information-set-dialog',
  imports: [
    CommonModule,
    FormsModule,
    CountryComboBoxComponent,
    CheckNewsletterComponent,
    ESalutationToOptionStringPipe,
  ],
  templateUrl: './user-information-set-dialog.component.html',
  styleUrls: ['./user-information-set-dialog.component.scss']
})
export class UserInformationSetDialogMHComponent extends UserInformationSetDialogComponent implements OnInit {

  async ngOnInit() {
    super.ngOnInit();
  }

  onCountryCodeChange(value: CountryDto) {
    if (this.countryList != undefined && this.countryList.length > 0) {
      this.userCopy.mobile = this.mobileNumberWithoutDialingCode;
      this.selectedCountryCode = value.dialingCode;
      if (this.selectedCountryCode != undefined) {
        this.userCopy.mobile = this.selectedCountryCode + this.userCopy?.mobile;
      }
      this.mobileNumberWithoutDialingCode = this.userCopy.mobile?.slice(this.selectedCountryCode?.length, this.userCopy.mobile.length);
      let country = this.countryList.find(c => c.dialingCode == this.selectedCountryCode);
      if (country?.countryPhoneNumberRegex != undefined && ENVIRONMENT.validation.useCountrySpecificMobileValidation) {
        this.inputValidationMobileRegexPattern = country.countryPhoneNumberRegex;
      }
    }
  }

  getMobileInputClass() {
    return this.userCopy.mobile && !this.isValidMobileNumber() ? 'is-invalid' : '';
  }

  getMailInputClass() {
    return this.userCopy.eMail && !this.isValidMail() ? 'is-invalid' : '';
  }

  isValidMobileNumber() {
    let regex = new RegExp(this.inputValidationMobileRegexPattern);
    if (this.userCopy.mobile != undefined && this.userCopy.mobile.length <= 0) {
      return true;
    }

    if (this.mobileNumberWithoutDialingCode != undefined && this.mobileNumberWithoutDialingCode.length > 0) {
      return regex.test(this.mobileNumberWithoutDialingCode);
    }
    return false;
  }

  isValidMail() {
    let regex = new RegExp(this.inputValidationEmailRegexPattern);
    if (this.userCopy.eMail != undefined) {
      return regex.test(this.userCopy.eMail);
    }
    return false;
  }

  onInputChange() {
    this.mobileNumberWithoutDialingCode = this.userCopy.mobile?.slice(this.selectedCountryCode?.length, this.userCopy.mobile.length);
  }

  protected async userInformationSetAsync(): Promise<boolean> {
    if (!this.isValidMobileNumber()) {
      return false;
    }

    let userInformationSetCommand: UserInformationSetCommand = new UserInformationSetCommand();
    userInformationSetCommand.eMail = this.userCopy.eMail;
    userInformationSetCommand.userAlias = this.userCopy?.userAlias;
    userInformationSetCommand.mobile = undefined;
    if (this.userCopy?.mobile != undefined) {
      userInformationSetCommand.mobile = this.userCopy?.mobile;
    }
    userInformationSetCommand.confirmationIsPreselected = true;
    userInformationSetCommand.newsletterSubscribed = this.userCopy?.newsletterSubscribed ? this.userCopy?.newsletterSubscribed : false;

    return await firstValueFrom(this.userService.userInformationSet(userInformationSetCommand)).then(() => {
      return true;
    }).catch((ex) => {
      this.logger.error(ex, this.constructor.name);
      let errorMessage = $localize`:@@UserInformationSetDialogSetInformationErrorMessage:Could not save your userinformation`;
      throw new BasicError(errorMessage, JSON.parse(ex.response).errorCode);
    });
  }
}
